const formatText = (text, length = 9) => {
  if (text === null || text === undefined) return 'null';
  if (text.length < length) return text;
  return `${text.slice(0, length - 3)}...`;
};

export default formatText;
